import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';

interface IPageHeaderContentProps {
  stackable?: boolean;
  paddingBottom?: number;
}

const PageHeaderContent = styled.section<IPageHeaderContentProps>`
  position: relative;
  z-index: ${theme.zIndex.contentHeader + 1};
  flex-flow: column nowrap;
  justify-content: center;
  width: 100%;
  align-items: center;

  @media (min-width: ${theme.breakpoint.small}px) {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    min-height: ${toRem(54)};
  }

  ${({ stackable }) =>
    stackable &&
    css`
      display: grid;
      grid-template-columns: 1fr;
      grid-gap: ${toRem(22)};
      justify-items: center;
      width: 100%;
      padding-bottom: ${toRem(11)};

      @media (min-width: ${theme.breakpoint.small}px) {
        margin-bottom: ${toRem(20)};
        padding-bottom: 0;
      }
    `}
`;

export default PageHeaderContent;
